var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -17 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450 479H62c-23 0-41-19-41-42V157h470v280c0 23-18 42-41 42zm0 0",
    fill: "#636363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M468 157H21v120l9 3 191 35h70l177-33v155c0 23-18 42-41 42h23c23 0 41-19 41-42V157zm0 0",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289 294v46h-66v-46zm0 0",
    fill: "#c9d2e3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223 294h66v21h-66zm0 0",
    fill: "#adbbd5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256 294h33l189-35c20-3 34-21 34-40v-69c0-23-19-42-42-42H42c-23 0-42 19-42 42v69c0 19 14 37 34 40l189 35zm0 0",
    fill: "#636363"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M470 108h-25c23 0 42 19 42 42v79c0 12-5 24-14 31l5-1c20-3 34-21 34-40v-69c0-23-19-42-42-42zm0 0",
    fill: "#494949"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M259 392l23-7c4-1 7-5 7-10v-35h-66v35c0 5 3 9 7 10l23 7h6zm0 0",
    fill: "#ffd664"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M273 340v48l9-3c4-1 7-5 7-10v-35zm0 0",
    fill: "#f9c646"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194 108h-63V87c0-5 5-10 11-10h41c6 0 11 5 11 10zm0 0",
    fill: "#ffd664"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180 77v8c0 6-5 11-10 11h-39v12h63V87c0-5-5-10-11-10zm0 0",
    fill: "#f9c646"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M381 108h-63V87c0-5 5-10 11-10h41c6 0 11 5 11 10zm0 0",
    fill: "#ffd664"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M367 77v8c0 6-4 11-10 11h-39v12h63V87c0-5-5-10-11-10zm0 0",
    fill: "#f9c646"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M366 77h-33V58c0-13-11-25-25-25H204c-14 0-25 12-25 25v19h-33V58c0-32 26-58 58-58h104c32 0 58 26 58 58zm0 0",
    fill: "#c9d2e3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#adbbd5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 58v19h15V58c0-13 11-25 25-25h-15c-13 0-25 12-25 25zm0 0M308 0h-15c33 0 59 26 59 58v19h14V58c0-32-26-58-58-58zm0 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.a4f0056bd911de502ca050f0777f779b.svg";
export { ForwardRef as ReactComponent };